import { render, staticRenderFns } from "./Traces.vue?vue&type=template&id=78c36ba9&scoped=true"
import script from "./Traces.vue?vue&type=script&lang=js"
export * from "./Traces.vue?vue&type=script&lang=js"
import style0 from "./Traces.vue?vue&type=style&index=0&id=78c36ba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c36ba9",
  null
  
)

export default component.exports